export default {
    savePlace: 'Save place',
    searchByName: 'Search by Name',
    search: 'Search',
    create: 'Create Place',
    namePlace: 'Name Place',
    latitude: 'Latitude',
    longitude: 'Longitude',
    radian: 'Radian (Meter)',
    congratulation: 'Congratulation',
    deletePlace: 'Delete Place',
    wantToDelete: 'Are you sure you want to delete',
    placeIsDeleted: 'Place is deleted'
}
